const EXTERNAL_NAME_ROUTE = `external`
const isExternalNameRoute = (name) => name === EXTERNAL_NAME_ROUTE
const REDIRECT_NAME_ROUTE = `redirect`
const isRedirectNameRoute = (name) => name === REDIRECT_NAME_ROUTE
const PENDING_SCREENING_COOKIE = `aeq_pending_screening`
const PENDING_COMPANY_COOKIE = `aeq_pending_company`
const PENDING_COOKIE_MAX_AGE_SECONDS = 10 * 60

function getQueryValue(value) {
  return Array.isArray(value) ? value[0] : value
}

function getScreeningFromRoute(route) {
  if (!route) {
    return null
  }

  try {
    return new URL(route, window.location.origin).searchParams.get(`screening`)
  } catch (_e) {
    const queryString = route.includes(`?`) ? route.split(`?`).slice(1).join(`?`) : route
    return new URLSearchParams(queryString).get(`screening`)
  }
}

function setPendingCookie(app, name, value) {
  const domain = app.$config?.pendingRedirectCookieDomain || app.$config?.public?.pendingRedirectCookieDomain
  const domainAttribute = domain ? `; Domain=${domain}` : ``
  const secureAttribute = window.location.protocol === `https:` ? `; Secure` : ``
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; Path=/; Max-Age=${PENDING_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${domainAttribute}${secureAttribute}`
}

function storePendingScreeningRedirect(app, route) {
  if (!process.client || !isRedirectNameRoute(route?.name)) {
    return
  }

  const redirectRoute = getQueryValue(route?.query?.route)
  const screening = getScreeningFromRoute(redirectRoute)
  const company = getQueryValue(route?.query?.company)

  if (screening) {
    setPendingCookie(app, PENDING_SCREENING_COOKIE, screening)
  }
  if (company) {
    setPendingCookie(app, PENDING_COMPANY_COOKIE, company)
  }
}

export default async ({ $auth, store, route, app }) => {
  storePendingScreeningRedirect(app, route)
  if (isExternalNameRoute(route?.name) || store.getters[`permissions/userIsExternal`]) {
    // $auth.strategy.token.reset()
    return
  }

  if (!!$auth.ctx.route.query.lang) {
    await $auth.ctx.app.i18n.setLocale($auth.ctx.route.query.lang)
  }

  if (!$auth?.loggedIn) {
    store.dispatch(`logout`)
    return
  }

  if (!!$auth.user) {
    if ($auth.user.companies) {

      store.commit(`companies/setUserCompanies`, $auth.user.companies)
      console.log('NUXT3:', $auth.user?.nuxt3_by_default)
      console.log('ALLOW NUXT3:', store.getters['companies/getAllowNuxt3'])

      if ($auth.user?.nuxt3_by_default === 'NUXT3' && store.getters['companies/getAllowNuxt3']) {
        window.location.assign(`/v3/client`);
      }
      if ($auth.user?.nuxt3_by_default === 'SHOW' && store.getters['companies/getAllowNuxt3']) {
        store.commit(`setShowNuxt3Modal`, true)
      }
    }
    if ($auth.user?.candidate_screenings?.length === 1) {
      store.commit(`menu/updateMenuState`, {
        name: `your_screening`,
        updatedValue: { to: `/screenings/${$auth.user?.candidate_screenings}` }
      })
    }

    if (!!$auth.user.lang && !$auth.ctx.route.query.lang) {
      await $auth.ctx.app.i18n.setLocale($auth.user.lang)
    }
  }
}
